import req, { createAxios } from './req'
import axios from 'axios'
// 导入上传文件

// 获取模板文件接口
export function downloadTemplate (params) {
  return req.get('/files/download-template', params)
}

// 上传文件至服务器
export function uploadFile (params) {
  const newreq = createAxios(axios.create(), false)
  return newreq.post('/files/upload-file', params, {
    headers: {
      'Content-Type': 'multipart/form-data;'
    }
  })
}

// 文件导入
export function haddleFile (fileId, params) {
  return req.get('/files/file-handle/' + fileId, params)
}

// 文件导出相关-可下载的列表
export function createExportList (params, files_type) {
  return req.post('/files/export-datalist/' + files_type, params)
}

// 获取配置详情
export function getFileTypes (params) {
  return req.get('/files/file-type-list', params)
}
